import Box from '@mui/material/Box';
// TL-LOGO: the mark built for the dark green bar, so it needs no
// brightness lift the way the previous dark-on-light logo did.
import logoSrc from '../../assets/img/tl-logo.png';

// Brand mark — uses the official TrustLab logo PNG.
// Sizes are tuned for navbar (md), drawer header (sm), and hero placements (lg).
//
// `sx` lands on the <img>, not the wrapper, so a caller can give the mark a
// fluid height — the header's `clamp(50px, 5.4vw, 68px)` and the footer's
// `max-height: 80px` both come from the reference and neither is one of the
// fixed `size` steps. It is spread last so it wins over `size`.
const Logo = ({ onClick, size = 'md', sx }) => {
  const heights = { sm: 26, md: 36, lg: 52 };
  const h = heights[size] || heights.md;

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        cursor: onClick ? 'pointer' : 'default',
        userSelect: 'none',
        lineHeight: 0,
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt="TrustLab Diagnostics"
        sx={{
          height: h,
          width: 'auto',
          display: 'block',
          ...sx,
        }}
      />
    </Box>
  );
};

export default Logo;
